import React, { useState, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles } from '@material-ui/core/styles';
import DialogoConfirmacion from '../../DialogoConfirmacion';
import { Box } from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
import SeriesService from '../../../services/series.service';

const useStyles = makeStyles((theme) => ({
	formControl: {
		marginTop: theme.spacing(1),
		marginBottom: theme.spacing(1),
		minWidth: '100%',
	},
}));

export default function SeriesDialog({
	open,
	onClose,
	series,
	onSave,
	onDelete,
}) {
	const classes = useStyles();
	const [formData, setFormData] = useState({
		id: '',
		serie: '',
		team: 'PERFUMERIA',
		description: '',
	});

	const [errors, setErrors] = useState({
		serie: '',
		description: '',
	});

	const [isSubmitting, setIsSubmitting] = useState(false);

	useEffect(() => {
		if (series) {
			setFormData({
				id: series.id,
				serie: series.serie,
				team: series.team,
				description: series.description,
			});
		} else {
			setFormData({
				id: '',
				serie: '',
				team: 'PERFUMERIA',
				description: '',
			});
		}
		// Resetear errores cuando se abre el diálogo
		setErrors({
			serie: '',
			description: '',
		});
	}, [series]);

	const validateForm = async () => {
		const newErrors = {
			serie: '',
			description: '',
		};

		if (!formData.serie.trim()) {
			newErrors.serie = 'La serie es requerida';
		} else {
			try {
				// Verificar si la serie ya existe
				const existingSeries = await SeriesService.get();
				const isDuplicate = existingSeries.some(
					(s) =>
						s.serie.toLowerCase() === formData.serie.toLowerCase() &&
						s.id !== formData.id
				);

				if (isDuplicate) {
					newErrors.serie = 'Esta serie ya existe';
				}
			} catch (error) {
				console.error('Error al validar serie:', error);
				newErrors.serie = 'Error al validar la serie';
			}
		}

		if (!formData.description.trim()) {
			newErrors.description = 'La descripción es requerida';
		}

		setErrors(newErrors);
		return Object.values(newErrors).every((error) => !error);
	};

	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData({
			...formData,
			[name]: value,
		});
		// Limpiar error cuando el usuario empieza a escribir
		if (errors[name]) {
			setErrors({
				...errors,
				[name]: '',
			});
		}
	};

	const handleSubmit = async () => {
		setIsSubmitting(true);
		const isValid = await validateForm();

		if (isValid) {
			onSave(formData);
		}
		setIsSubmitting(false);
	};

	return (
		<>
			<Dialog open={open} onClose={onClose} aria-labelledby='form-dialog-title'>
				<DialogTitle id='form-dialog-title'>
					{series ? 'Editar Serie' : 'Añadir Serie'}
				</DialogTitle>
				<DialogContent dividers style={{ minHeight: '8rem' }}>
					<TextField
						autoFocus
						margin='dense'
						id='serie'
						name='serie'
						label='Serie'
						type='text'
						fullWidth
						value={formData.serie}
						onChange={handleChange}
						error={!!errors.serie}
						helperText={errors.serie}
						disabled={isSubmitting}
					/>
					<FormControl className={classes.formControl}>
						<InputLabel id='team-label'>Equipo</InputLabel>
						<Select
							labelId='team-label'
							id='team'
							name='team'
							value={formData.team}
							onChange={handleChange}>
							<MenuItem value='PERFUMERIA'>PERFUMERIA</MenuItem>
							<MenuItem value='COMPLEMENTOS'>COMPLEMENTOS</MenuItem>
						</Select>
					</FormControl>
					<TextField
						margin='dense'
						id='description'
						name='description'
						label='Descripción'
						type='text'
						fullWidth
						multiline
						rows={4}
						value={formData.description}
						onChange={handleChange}
						error={!!errors.description}
						helperText={errors.description}
						disabled={isSubmitting}
					/>
				</DialogContent>
				<DialogActions>
					<Box
						display='flex'
						justifyContent='space-between'
						width='100%'
						px={1}>
						<Box display='flex' justifyContent='space-between'>
							{series && (
								<DialogoConfirmacion
									title='Eliminar Serie'
									textButtonOpen='Eliminar'
									buttonProps={{
										color: 'secondary',
										variant: 'outlined',
									}}
									buttonConfirmarProps={{
										color: 'secondary',
										variant: 'contained',
									}}
									textButtonConfirmar='Eliminar'
									textButtonCancelar='Cancelar'
									handleConfirmar={() => {
										onDelete(series);
										onClose();
									}}>
									<Alert severity='warning'>
										<AlertTitle>{series.serie}</AlertTitle>
										¿Estás seguro de que deseas eliminar esta serie?
									</Alert>
								</DialogoConfirmacion>
							)}
						</Box>
						<Box>
							<Button
								onClick={onClose}
								variant={'outlined'}
								style={{ marginRight: '0.5rem' }}
								disabled={isSubmitting}>
								Cancelar
							</Button>
							<Button
								onClick={handleSubmit}
								color={'primary'}
								variant={'contained'}
								disabled={isSubmitting}>
								Guardar
							</Button>
						</Box>
					</Box>
				</DialogActions>
			</Dialog>
		</>
	);
}
